import { StepperFormService } from "./services";
import { StepperFormConstants } from "./constants";
import { getPrefilledDataObject, initData } from "@containers/ApplicationKYC/Utilities";
import { unMapDraftData } from "@containers/ApplicationKYC/Utilities/unMapDraftData";
import { parsePhone } from "@utilities";
import _ from "lodash";

const getFormDraft = () => async (dispatch, getState) => {
  dispatch({ type: StepperFormConstants.GET_FORM_DRAFT_REQUEST });

  const prefiller = (data) => {
    const {
      KYCReducers: { applicationKYC }
    } = getState();
    const {
      applicationState: { prefillData }
    } = applicationKYC;
    const dataAddress = prefillData.addressSplit
      ? {
        addressCountry: prefillData.addressSplit.country || "LT",
        addressCity: prefillData.addressSplit.city,
        addressStreet: prefillData.addressSplit.street,
        addressHouse: prefillData.addressSplit.house,
        addressFlat: prefillData.addressSplit.flat
      }
      : {},
      clientCeoName = {
        clientCeoName: prefillData.managerFirstName,
        clientCeoSurname: prefillData.managerLastName
      };
    const representative = applicationKYC.representative;
    const whoOpenAccount =
      prefillData.representative && prefillData.managerCode !== representative.code
        ? "CMP2"
        : "CMP1";

    const obj = Object.assign(
      initData,
      getPrefilledDataObject(
        prefillData,
        applicationKYC.company,
        whoOpenAccount,
        parsePhone,
        dataAddress,
        clientCeoName,
        representative
      )
    );
    return _.merge(data, obj);
  }

  try {
    const response = await StepperFormService.getFormDraft();
    let data;
    let currentStep;
    let clientFullName;

    if (response === "") {
      data = prefiller({});
    } else {
      const parsedDraftData = JSON.parse(response.data);
      const unMapedData = unMapDraftData(parsedDraftData);
      currentStep = parsedDraftData.currentStep;
      clientFullName = response.clientFullName;
      if (parsedDraftData.requiresPeriodicReviewPrefill) {
        data = prefiller(unMapedData.personData);
      } else {
        data = unMapedData.personData;
      }
    }
    return dispatch({
      type: StepperFormConstants.GET_FORM_DRAFT_SUCCESS,
      payload: { ...response, clientFullName: clientFullName, data: { personData: data, currentStep: currentStep || 0 } }
    });
  } catch (error) {
    dispatch({ type: StepperFormConstants.GET_FORM_DRAFT_ERROR, error });
  }
};

const saveFormDraft = data => async (dispatch, getState) => {
  dispatch({ type: StepperFormConstants.SAVE_FORM_DRAFT_REQUEST });
  try {
    const {
      StepperFormReducer: {
        formDraft: { finishedSteps }
      }
    } = getState();
    if (finishedSteps > data.data.currentStep) data.data.currentStep = finishedSteps;
    await StepperFormService.saveFormDraft(data);
    dispatch({
      type: StepperFormConstants.SAVE_FORM_DRAFT_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({ type: StepperFormConstants.SAVE_FORM_DRAFT_ERROR, error });
    throw error;
  }
};

const closeInfoBubble = () => dispatch =>
  dispatch({ type: StepperFormConstants.CLOSE_INFO_BUBBLE });

const setCurrentStep = step => dispatch =>
  dispatch({ type: StepperFormConstants.SET_CURRENT_STEP, payload: step });

export const StepperFormActions = { getFormDraft, closeInfoBubble, saveFormDraft, setCurrentStep };
